import React from 'react';
import PropTypes from 'prop-types';
import { Tabs, Card } from 'antd';

import EmployeeHeader from './employeeHeader';
import EmployeeBasic from './Tabs/basic';
import IdCardInfo from './Tabs/idCard';
import HealthInsurance from './Tabs/healthInsurance';
import BankInfo from './Tabs/bank';
import ContactInfo from './Tabs/contact';
import DocumentsInfo from './Tabs/documents';
// import Payroll from './Tabs/payroll';
// import Allowance from './Tabs/allowance';
// import Deductions from './Tabs/deductions';

const { TabPane } = Tabs;

const EmployeeDetails = ({
  employee,
  designations,
  locations,
  portfolios,
  productTypes,
  stages,
  onBasicInfoUpdate,
  onIdCardInfoUpdate,
  onHealthInsuranceUpdate,
  onBankInfoUpdate,
  onContactInfoUpdate,
  onDocumentAdd,
  onDocumentUpdate,
  onDocumentDelete,
  onRelieveEmployeeSubmit,
  onRejoinEmployeeSubmit,
  onResetEmployeeIdSubmit,
  onDocumentDownload,
  onDocumentView,
  uploadDocument,
  ability,
}) => {
  return (
    <Card className="employeesCard">
      <EmployeeHeader
        employee={employee}
        ability={ability}
        onResetEmployeeIdSubmit={onResetEmployeeIdSubmit}
      />
      <p>&nbsp;</p>
      <Tabs
        defaultActiveKey="1"
        type="card"
        size="small"
        key="1"
        className="employeesTab"
      >
        <TabPane tab={<span>Basic Info</span>} key="1">
          <EmployeeBasic
            employee={employee}
            designations={designations}
            locations={locations}
            portfolios={portfolios}
            productTypes={productTypes}
            stages={stages}
            onBasicInfoUpdate={onBasicInfoUpdate}
            onRelieveEmployeeSubmit={onRelieveEmployeeSubmit}
            onRejoinEmployeeSubmit={onRejoinEmployeeSubmit}
            ability={ability}
          />
        </TabPane>
        <TabPane tab={<span>ID Card / DRA</span>} key="2">
          <IdCardInfo
            employee={employee}
            onIdCardInfoUpdate={onIdCardInfoUpdate}
            ability={ability}
          />
        </TabPane>
        <TabPane tab={<span>Health Insurance</span>} key="3">
          <HealthInsurance
            employee={employee}
            onHealthInsuranceUpdate={onHealthInsuranceUpdate}
            ability={ability}
          />
        </TabPane>
        {(ability.toViewBankInfo || ability.toEditBankInfo) && (
          <TabPane tab={<span>Bank Info</span>} key="4">
            <BankInfo
              employee={employee}
              onBankInfoUpdate={onBankInfoUpdate}
              ability={ability}
            />
          </TabPane>
        )}
        <TabPane tab={<span>Contact</span>} key="5">
          <ContactInfo
            employee={employee}
            onContactInfoUpdate={onContactInfoUpdate}
            ability={ability}
          />
        </TabPane>
        <TabPane tab={<span>Documents</span>} key="6">
          <DocumentsInfo
            employee={employee}
            onDocumentAdd={onDocumentAdd}
            onDocumentUpdate={onDocumentUpdate}
            onDocumentDelete={onDocumentDelete}
            onDocumentDownload={onDocumentDownload}
            uploadDocument={uploadDocument}
            onDocumentView={onDocumentView}
            ability={ability}
          />
        </TabPane>
        {/* <TabPane tab={<span>Payroll</span>} key="6">
          <Payroll ability={ability} />
        </TabPane>
        <TabPane tab={<span>Allowance</span>} key="7">
          <Allowance ability={ability} />
        </TabPane>
        <TabPane tab={<span>Deductions</span>} key="8">
          <Deductions ability={ability} />
        </TabPane> */}
      </Tabs>
    </Card>
  );
};

EmployeeDetails.defaultProps = {};

EmployeeDetails.propTypes = {
  employee: PropTypes.object.isRequired,
  designations: PropTypes.array.isRequired,
  locations: PropTypes.array.isRequired,
  onBasicInfoUpdate: PropTypes.func.isRequired,
  onIdCardInfoUpdate: PropTypes.func.isRequired,
  onHealthInsuranceUpdate: PropTypes.func.isRequired,
  onBankInfoUpdate: PropTypes.func.isRequired,
  onContactInfoUpdate: PropTypes.func.isRequired,
  onDocumentAdd: PropTypes.func.isRequired,
  onDocumentUpdate: PropTypes.func.isRequired,
  onDocumentDelete: PropTypes.func.isRequired,
  onRelieveEmployeeSubmit: PropTypes.func,
  ability: PropTypes.object.isRequired,
};

export default EmployeeDetails;
